function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.30325 11.7759L1.33325 14.0603V1.98569C1.33325 1.81259 1.40349 1.64657 1.52851 1.52417C1.65354 1.40177 1.82311 1.33301 1.99992 1.33301H13.9999C14.1767 1.33301 14.3463 1.40177 14.4713 1.52417C14.5963 1.64657 14.6666 1.81259 14.6666 1.98569V11.1232C14.6666 11.2963 14.5963 11.4623 14.4713 11.5847C14.3463 11.7071 14.1767 11.7759 13.9999 11.7759H4.30325ZM4.66659 5.90177V7.20713H5.99992V5.90177H4.66659ZM7.33325 5.90177V7.20713H8.66659V5.90177H7.33325ZM9.99992 5.90177V7.20713H11.3333V5.90177H9.99992Z"
});

function SvgDialogIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDialogIcon);
export default __webpack_public_path__ + "static/media/dialog-icon.9c394e17.svg";
export { ForwardRef as ReactComponent };